module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/summary-infranctions-by-day-report/summary-infranctions-by-day-report.component.css
// module id = ./src/app/summary-infranctions-by-day-report/summary-infranctions-by-day-report.component.css
// module chunks = main